
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import CookiePolicy from './CookiePolicy';

function CookiePolicyMain() {
    useEffect(() => {
        document.title = "Cookie Policy | InvoicePoint"
   }, []);
   const[loader, SetLoader] = useState(false)
    useEffect(() =>
    setTimeout(() =>{
        SetLoader(true)
    },1500)[loader]  
    )
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <CookiePolicy/>
            <Footer/>
        </Fragment>
    )
    
}

export default CookiePolicyMain;